import 'react-native-url-polyfill/auto';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { createClient } from '@supabase/supabase-js';

import { Platform } from 'react-native';

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL || 'http://localhost:54321';
const anonKey =
  process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9...';

// Em React Native não existe cookie/URL de browser: sem `storage` configurado
// com AsyncStorage, o client guarda a sessão só em memória e ela some ao
// fechar o app, quebrando o requisito de "logar uma vez e permanecer logada"
// (Etapa 3 / spec S01). Única instância do módulo (nunca recriado) — duas
// instâncias competiriam pela mesma storage/refresh de token.
export const supabase = createClient(supabaseUrl, anonKey, {
  auth: {
    storage: AsyncStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: Platform.OS === 'web',
  },
});
